import { render, staticRenderFns } from "./sleep-report-configuration.vue?vue&type=template&id=2d71b00b&scoped=true"
import script from "./sleep-report-configuration.vue?vue&type=script&lang=js"
export * from "./sleep-report-configuration.vue?vue&type=script&lang=js"
import style0 from "./sleep-report-configuration.vue?vue&type=style&index=0&id=2d71b00b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71b00b",
  null
  
)

export default component.exports